module.exports = __webpack_public_path__ + "img/icon-k-gray.75e8e63b.svg";